import { createFileRoute } from '@tanstack/react-router'
import { StandingsTable } from '../components/StandingsTable'

// Season N's table, the full form of designs/20261017-seasons.md §4: it
// stays where it is after the next season starts.
export const Route = createFileRoute('/l/$slug/s/$n/standings')({
  params: { parse: (p) => ({ n: Number(p.n) }), stringify: (p) => ({ n: String(p.n) }) },
  component: SeasonStandings,
})

function SeasonStandings() {
  const { slug, n } = Route.useParams()
  return <StandingsTable slug={slug} season={n} />
}
